import CardDefault from "components/Cards/CardDefault/index";
import { Box, Flex, Text, Skeleton } from "@chakra-ui/react";
import HeaderTable from "../HeaderTable";
import { RelatorioUnidadesPaginadoItem } from "features/relatorios/typings";
import { Empty } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import ItemUnidade from "./../ItemUnidade/index";
import useRelatorioUnidadesTotais from "core/features/relatorios/hooks/useRelatorioUnidadesTotais";
import InfiniteScrollLoader from "components/InfiniteScrollLoader";

interface RelatorioUnidadeContentProps {
  data: RelatorioUnidadesPaginadoItem[];
  search?: string;
  setSearch: (search?: string) => void;
  setExportType: React.Dispatch<
    React.SetStateAction<
      | {
          type: "pdf" | "excel";
        }
      | undefined
    >
  >;
  hasNextPage: boolean;
  fetchNextPage: () => any;
  isLoading?: boolean;
  isFetchingNextPage?: boolean;
  onFiltro?: () => void;
  badge?: number;
}

export default function RelatorioUnidadeContent({
  data,
  search,
  setSearch,
  setExportType,
  fetchNextPage,
  hasNextPage,
  isLoading,
  isFetchingNextPage,
  onFiltro,
  badge,
}: RelatorioUnidadeContentProps) {
  const { data: total, isLoading: isLoadingTotal } =
    useRelatorioUnidadesTotais();

  return (
    <CardDefault p={0} pt={"12px"} pb={!isLoading ? 0 : "24px"}>
      <Box px="24px">
        <HeaderTable
          onFiltro={onFiltro}
          badge={badge}
          value={search || ""}
          onSearch={setSearch}
          onExportExcel={
            isLoading ? undefined : () => setExportType({ type: "excel" })
          }
          onExportPdf={
            isLoading ? undefined : () => setExportType({ type: "pdf" })
          }
        />

        <Flex
          mt={3}
          pl="16px"
          pr={6}
          justifyContent="space-between"
          alignItems="center"
        >
          <Text fontWeight="bold">
            Total de pessoas:{" "}
            {isLoadingTotal ? (
              <Skeleton w="40px" h="18px" display="inline-block" mb={-1} />
            ) : (
              total?.totalPessoas
            )}
          </Text>
        </Flex>
      </Box>

      <Box mt={4}>
        {!isLoading && !data.length ? (
          <Box my={4}>
            <Empty description="Sem unidades cadastradas" />
          </Box>
        ) : null}
        {data.length ? (
          <>
            <InfiniteScroll
              dataLength={data.length}
              next={() => {
                fetchNextPage();
              }}
              hasMore={!!hasNextPage}
              loader={isFetchingNextPage ? <InfiniteScrollLoader /> : null}
            >
              {!isLoading && data.length
                ? data.map((item) => (
                    <ItemUnidade item={item} key={item.unidadeId} />
                  ))
                : null}
            </InfiniteScroll>
          </>
        ) : null}
      </Box>
    </CardDefault>
  );
}
